import { QueryKey } from "@tanstack/react-query";
import { CUSTOM_HEADERS } from "./constants";

function isEmpty(value: unknown): boolean {
  if (value == null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  if (typeof value === "string") return value.length === 0;
  return false;
}

export const makeQueryKey = ({
  fetcherName,
  params,
  variedHeaders,
}: {
  fetcherName: string;
  params?: string | (Record<string, unknown> & { [CUSTOM_HEADERS]?: Record<string, string> });
  variedHeaders?: string[];
}): QueryKey => {
  let cachedParams = params;
  if (params && typeof params !== "string") {
    const { [CUSTOM_HEADERS]: headers, ...restParams } = params;

    cachedParams = restParams;

    if (headers && variedHeaders) {
      cachedParams[CUSTOM_HEADERS] = {};
      for (const cachedHeader of variedHeaders) {
        if (headers[cachedHeader]) {
          cachedParams[CUSTOM_HEADERS][cachedHeader] = headers[cachedHeader];
        }
      }
    }
  }

  return [fetcherName, cachedParams].filter((v) => !isEmpty(v));
};

const queryNames = new Set();

export const registerQuery = (queryName: string): void => {
  if (queryNames.has(queryName)) {
    throw new Error(`There is already a query with name ${queryName}`);
  }

  queryNames.add(queryName);
};

// Test-only: the registry is module-global and intentionally persists in
// production (fetchers are created once at module load). Tests create fetchers
// repeatedly, so the setup must clear it between runs — otherwise a re-run with
// the same fetcherName throws "already a query with name …". Called from
// test/vitest.setup.ts alongside queryClient.clear().
export const __clearRegisteredQueryNamesForTests = (): void => {
  queryNames.clear();
};
